import { API_BASE_URL } from '../config';

const baseUrl= API_BASE_URL;

const BASE_URL = `${baseUrl}staff`;


const StaffService = {
  async getStaff(token) {
    if (!token) {
      throw new Error('Authentication token not provided');
    }

    const response = await fetch(BASE_URL, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    
    if (response.status === 401) {
      throw new Error('Authentication failed');
    }
    
    if (!response.ok) {
      throw new Error('Failed to fetch staff');
    }
    return response.json();
  },

  async createStaff(token, staffData) {
    if (!token) {
      throw new Error('Authentication token not provided');
    }

    const response = await fetch(BASE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(staffData),
    });
    
    if (response.status === 401) {
      throw new Error('Authentication failed');
    }
    
    if (!response.ok) {
      throw new Error('Failed to create staff');
    }
    return response.json();
  },

  async updateStaff(token, id, staffData) {
    if (!token) {
      throw new Error('Authentication token not provided');
    }

    const response = await fetch(`${BASE_URL}/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(staffData),
    });
    
    if (response.status === 401) {
      throw new Error('Authentication failed');
    }
    
    if (!response.ok) {
      throw new Error('Failed to update staff');
    }
    return response.json();
  },
};


export default StaffService;
